<template>
	<div class="margin-left">
		<div class="cont bg-white">
			<div class="bg-white margin-lr dvly padding-tb">
				<div class="flex align-center justify-center">
					<div class="round nocheck check"></div>
					<div class="noxian"></div>
					<div class="round nocheck" :class="is_real > 0?'check':''"></div>
					<div class="noxian"></div>
					<div class="round nocheck " :class="is_real == 2?'check':is_real == 3?'noguo':''"></div>
				</div>
				<div class="flex justify-between"
					style="padding-left: 60rpx;padding-right: 60rpx;width: 545px;margin: 21px auto;">
					<div class="text-sm text-666">上传证件</div>
					<div class="text-sm text-666">信息审核</div>

					<div class="text-sm text-666" v-if="is_real == 3">审核不过</div>
					<div class="text-sm text-666" v-else>审核通过</div>
				</div>
			</div>
			<div v-if="is_real == 3">{{reason}}</div>
			<div class="form">
				<el-form :model="business" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="企业全称" prop="name">
						<el-input v-model="business.name" placeholder="请输入营业执照上的企业全称"></el-input>
					</el-form-item>
					<el-form-item label="营业执照" prop="photo">
						
						<el-upload
						  class="avatar-uploader" v-if="is_real == 0||is_real == 3"
						  action="https://manage.ciiply.com/api/pc/user/upFile"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload">
						  <img v-if="imageUrl" :src="imageUrl" class="portrait">
						  <div v-else class="blockup flex flex-direction justify-center align-center ">
						  	<img src="../../../assets/img/upvideo.png" >
						  	<p>上传营业执照</p>
						  </div>
						</el-upload>
						<div v-else class="text-left"><img  :src="imageUrl" class="portrait"></div>
						<!-- <el-upload
						  action="https://jsonplaceholder.typicode.com/posts/"
						  list-type="picture-card"
						  :on-preview="handlePictureCardPreview"
						  :on-remove="handleRemove">
						  
						</el-upload> -->
						
					</el-form-item>
					<el-form-item label="企业介绍" prop="photo">
						<el-input type="textarea" :disabled="is_real == 0||is_real == 3?false:true" v-model="business.desc" placeholder="请描述详情企业介绍"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="btns text-white pointer" @click="sub" v-if="is_real == 0||is_real == 3">确认提交</div>
			<p>如有疑问请联系平台客服：400-212-22</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				is_real: 0, //0未申请，1是申请中，2是通过，3驳回
				imageUrl:'',//营业执照
				business:{
					name:'',//企业全称
					desc:'',//企业介绍
				}, 
				reason:'',//被拒原因
				rules: {
					name: [ { message: '请输入营业执照上的企业全称', trigger: 'blur' },],
					
					desc: [{
						message: '请描述详情企业介绍',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.getinfo()
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type) {
				let typeq = {
					type: type,
					typeone: ''
				}
				this.$emit('gettype', typeq)
			},
			/**
			* 上传营业执照
			 * */
			handleAvatarSuccess(file){
				this.imageUrl = file.data.url;
			},
			beforeAvatarUpload(){},
			getinfo(){
				this.ajax('get', '/api/pc/userReal/getReal', {
					type:2,
				}, res => {
					// res = res.data
					if(res.status == 200){
						this.is_real = res.data.is_real
						if(res.data.is_real != 0){
							this.business.name = res.data.name
							this.business.desc = res.data.content
							
							this.imageUrl = res.data.img
							if(res.data.is_real == 3){
								this.reason = res.data.reason
							}
						}
					}else{
						this.$message.info(res.msg);
					}
				})
			},
			sub(){
				this.ajax('post', '/api/pc/userReal/company_certification', {
					name:this.business.name,
					content:this.business.desc,
					img:this.imageUrl
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.$message.success('提交成功');
						this.getinfo()
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.cont {
		width: 920px;
		padding-top: 80px;
		padding-bottom: 80px;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2);
		border-radius: 20px;
	}
	
	.avatar-uploader{
		width: 345px;
		
	}
	
	.portrait{
		width: 345px;
		height: 194px;
	}

	.blockup{
		width: 345px;
		height: 194px;
		background: #F7F7F7;
		border: 1px solid rgba(220,217,217,0.6500);
		border-radius: 10px;
	}

	.btns {
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2);
		border-radius: 30px;
		margin: 0 auto 40px;
	}
	.form{
		padding: 0 60px 0 35px;
	}
	/deep/ .el-input__inner{
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
		height: 54px;
	}
	/deep/ .el-textarea__inner{
		height: 126px;
		background: rgba(230,230,230,0.3);
		border: 1px solid #E6E6E6;
	}

	// 步骤器
	.nocheck {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: rgba(11, 131, 124, 0.2);
	}

	.check {
		position: relative;

		&::after {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(11, 131, 124, 1);
			content: '';
		}
	}

	.noguo {
		position: relative;
		background: rgba(242, 16, 64, 0.2) !important;

		&::after {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 13px;
			height: 13px;
			border-radius: 50%;
			background: rgba(242, 16, 64, 1);
			content: '';
		}
	}

	.noxian {
		width: 209px;
		height: 2px;
		background: rgba(11, 131, 124, 0.2);
	}

	//步骤器
</style>



// WEBPACK FOOTER //
// src/components/my/attestation/enterprise.vue